import { render, staticRenderFns } from "./CatalogDate.vue?vue&type=template&id=96f0ce40&"
import script from "./CatalogDate.vue?vue&type=script&lang=ts&"
export * from "./CatalogDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports